<div class="content-container">
  <div class="chart-content">
    <div class="button-row">
      <button class="btn-cancel" (click)="handleCancel()">
        <span>Cancel</span>
      </button>
    </div>
    <div class="chart-layout"></div>
  </div>
  <div class="add-charts">
    <add-chart></add-chart>
  </div>
</div>